<!--  -->
<template>
  <div>
    <div class="choosecover chooseitem">
      <div class="text_wei">
        关键词：
      </div>
      <el-input v-model="keywordobj.keywordwritten" placeholder="请输入关键字" />
    </div>
    <div class="choosecover">
      <div class="text_wei">
        文案内容：
      </div>
      <el-input v-model="keywordobj.keywordtext" placeholder="请输入文案内容" />
    </div>
    <div class="btn_determine">
      <el-button @click="keywordbtn">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      keywordobj: {
        keywordwritten: '',
        keywordtext: ''
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    keywordbtn() {
      this.$emit('keywordbtn', this.keywordobj)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.choosecover{
  display: flex;
  align-items: center;
}
.chooseitem{
  margin-bottom: 30px;
}
.text_wei {
  flex-shrink: 0;
}
.btn_determine{
  margin-top: 30px;
  text-align: right;
}
</style>
